var numeral = require('numeral');
import moment from 'moment'
import { EventBus } from './event-bus'
import User from '@/store/Models/User'
import Tenant from '@/store/Models/Tenant'
var slugifyPackage = require('slugify')
import QuilityAPI from '@/store/API/QuilityAPI.js';

import { weekdiff } from '@/components/utils/BusinessTimeDateDiff.js'
import { get } from 'superagent';

export default {
    data: function() {
        return {}
    },
    mounted: function() {

    },
    methods: {
        slugify(str) {
            return slugifyPackage(str, '_');
        },
        formatCurrency(n) {
            return '$' + numeral(n).format('0,0');
        },
        formatShortCurrency(n) {
            return numeral(n).format('($0[.]0 a)');
        },
        formatLongCurrency(n) {
            return numeral(n).format('($0,0.00)');
        },
        formatPercentage(n) {
            return numeral(n * 100).format('0,0.0') + '%';
        },
        formatNumber(n, f) {
            return numeral(n).format(f);
        },
        formatPhoneNumber: function(phoneNumberString) {
            var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
            if (match) {
                return '(' + match[1] + ') ' + match[2] + '-' + match[3]
            }
            return ""
        },
        hasRole(r) {
            //r should be an array if not conver the string to an array
            var rs = r
            if (typeof r == "string") {
                rs = [r]
            }
            for (var i = 0; i < rs.length; i++) {
                if (this.$auth.auth_user["http://quility.com/roles"].indexOf(rs[i]) > -1) {
                    return true;
                }
            }
            return false;
        },
        notRole(r) {
            //r should be an array if not conver the string to an array
            var rs = r
            if (typeof r == "string") {
                rs = [r]
            }
            for (var i = 0; i < rs.length; i++) {
                if (this.$auth.auth_user["http://quility.com/roles"].indexOf(rs[i]) > -1) {
                    return false;
                }
            }
            return true;
        },
        hasPermission(r) {
            if (this.hasRole('SuperAdmin')) {
                return true;
            }
            //r should be an array if not conver the string to an array
            var rs = r
            if (typeof r == "string") {
                rs = [r]
            }
            for (var i = 0; i < rs.length; i++) {
                if (this.user.permissions.indexOf(rs[i]) > -1) {
                    return true;
                }
            }
            return false;
        },
        hasTenant(id) {
            //r should be an array if not conver the string to an array
            var rs = id
            if (typeof id == "number") {
                rs = [id]
            }
            for (var i = 0; i < rs.length; i++) {
                if (this.all_tenants.find(item => item.ID == rs[i])) {
                    return true;
                }
            }
            return false;
        },
        /** todo_Division */
        hasDivision(r) {
            //r should be an array if not conver the string to an array
            var rs = r
            if (typeof r == "string") {
                rs = [r]
            }
            for (var i = 0; i < rs.length; i++) {
                if (this.divisions.indexOf(rs[i]) > -1) {
                    return true;
                }
            }
            return false;
        },
        formatDate(d) {
            if (d == null) {
                return ''
            }
            return moment(d).format('YYYY-MM-DD');
        },
        formatReadableDate(d) {
            if (d == null) {
                return ''
            }
            return moment(d).format('MMM D, YYYY');
        },
        formatDateTime(d) {
            return moment(d).format('YYYY-MM-DD LT');
        },
        formatDateDash(d) {
            return moment(d).format('MM-DD-YYYY');
        },
        formatDateCalendar(d) {
            return moment(d).calendar(null, {
                sameDay: '[Today]',
                nextDay: '[Tomorrow]',
                nextWeek: 'dddd',
                lastDay: '[Yesterday]',
                lastWeek: '[Last] dddd',
                sameElse: 'ddd, MMM Do'
            });;
        },
        formatDateCalendarWithYear(d) {
            return moment(d).calendar(null, {
                sameDay: '[Today]',
                nextDay: '[Tomorrow]',
                nextWeek: 'dddd',
                lastDay: '[Yesterday]',
                lastWeek: '[Last] dddd',
                sameElse: 'ddd, MMM Do, YYYY'
            });;
        },
        dateDaysSince(d) {
            return moment().diff(d, 'days')
        },
        monthFromDate(d) {
            return moment(d).format('MMMM');
        },
        formatMonthDay(d) {
            return moment(d).format('MM/D');
        },
        monthSimpleDate(d) {
            return moment(d).format('MMM Do');
        },
        formatDateWithDay(d) {
            return moment(d).format('ddd, MMM Do');
        },
        relativeDate(d) {
            return moment(d).fromNow()
        },
        titleCase(string) {
            var sentence = string.toLowerCase().split(" ");
            for (var i = 0; i < sentence.length; i++) {
                sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
            }
            return sentence.join(' ');
        },
        showError(msg, details) {
            if (typeof details == 'undefined') {
                details = null
            }
            EventBus.$emit('showError', { 'text': msg, 'details': details })
        },
        showWarning(msg) {
            EventBus.$emit('showWarning', msg)
        },
        showInfo(msg) {
            EventBus.$emit('showInfo', msg)
        },
        showSuccess(msg) {
            EventBus.$emit('showSuccess', msg)
        },
        dispatchJob(job) {
            EventBus.$emit('dispatchJob', job)
        },
        getAgentIcon: function(level) {
            switch (level) {
                case 'Agency Owner':
                    return 'fas fa-store'
                    break;
                case 'Agency Director':
                    return 'fas fa-store'
                    break;
                case 'Regional Agency Director':
                    return 'fas fa-store-alt'
                    break;
                case 'Managing Vice President':
                    return 'far fa-building'
                    break;
                case 'Senior Vice President':
                    return 'fas fa-building'
                    break;
                case 'Executive Vice President':
                    return 'fas fa-building'
                    break;
                case 'Associate Partner':
                    return 'fas fa-city'
                    break;
                case 'Senior Partner':
                    return 'fas fa-city'
                    break;
                case 'Managing Partner':
                    return 'fas fa-city'
                    break;
                default:
                    return 'far fa-user'
            }
        },
        indexByKey(id, data, key) {
            if (typeof key == 'undefined') {
                key = 'id';
            }
            for (var i = 0; i < data.length; i++) {
                if (data[i][key] == id) {
                    return i;
                }
            }
            return -1;
        },
        maybeAutoStartDemo(demo_name) {
            //disabling demos for now. 
            return;
            //check if the agent_config object has an entry for this demo.
            var demos_seen = this.getConfig("DemosSeen");
            if (demos_seen == null || demos_seen.indexOf(demo_name) == -1) {
                if (typeof this.startDemo == 'function') {
                    this.startDemo();
                }
                if (typeof this.user.config.DemosSeen == 'undefined') {
                    var demos = []
                } else {
                    demos = this.getConfig('DemosSeen')
                }
                demos.push(demo_name)
                this.updateConfig('DemosSeen', demos, 'json');
            }
        },
        updateConfig(key, value, type) {
            return QuilityAPI.updateConfig(key, value, type)
        },
        updateAppConfig(key, value, type) {
            return QuilityAPI.updateAppConfig(key, value, type, this.user.Agent.AgentID)
        },
        getConfig(key) {
            if (typeof this.user.config[key] == 'undefined') {
                return null;
            }
            return this.user.config[key].ConfigValue;
        },
        getBusinessWeeks(date) {
            // build moment object
            // that represents the
            // given date
            const day = moment.utc(date)

            // determine the day of week
            // and use it to get the
            // values needed to determine
            // the begin and end dates
            const dayOfWeek = day.format("dddd").toLowerCase()
            const saturdaydiff = weekdiff[dayOfWeek].saturday
            const fridaydiff = weekdiff[dayOfWeek].friday

            return {
                'beginDate': day.clone().add(saturdaydiff, 'days').format("YYYY-MM-DD"),
                'endDate': day.clone().add(fridaydiff, 'days').format("YYYY-MM-DD")
            }
        },
        getBeginEndBusinessWeeks(begindate, enddate) {

            const begindateData = this.getBusinessWeeks(begindate)
            const enddateData = this.getBusinessWeeks(enddate)

            return {
                'beginDateRange': {
                    'begindate': begindateData.beginDate,
                    'enddate': begindateData.endDate
                },
                'endDateRange': {
                    'begindate': enddateData.beginDate,
                    'enddate': enddateData.endDate
                }
            }
        },
        getBusinessMonths(date) {
            // build moment object
            // that represents the
            // given date
            const day = moment.utc(date)

            // determine the day of week
            // and use it to get the
            // values needed to determine
            // the begin and end dates

            let endDate
            const curmonth = day.month()

            const firstofmonth = day.clone().startOf('month').format("dddd")
            const endofmonth = day.clone().endOf('month').format("dddd")

            const firstDiff = weekdiff[firstofmonth].saturday
            const endDiff = weekdiff[endofmonth].friday

            // determine if the calculated end
            // is in the next month. if so then
            // then return that end date minus 7 days

            if (day.clone().endOf('month').add(endDiff, 'days').month() != curmonth) {
                endDate = day.clone().endOf('month').add(endDiff, 'days').subtract(7, 'days').format("YYYY-MM-DD")
            } else {
                endDate = day.clone().endOf('month').add(endDiff, 'days').format("YYYY-MM-DD")
            }

            return {
                'beginDate': day.clone().startOf('month').add(firstDiff, 'days').format("YYYY-MM-DD"),
                'endDate': endDate
            }
        },
        getBeginEndBusinessMonths(begindate, enddate) {

            const begindateData = this.getBusinessMonths(begindate)
            const enddateData = this.getBusinessMonths(enddate)

            return {
                'beginDateRange': {
                    'begindate': begindateData.beginDate,
                    'enddate': begindateData.endDate
                },
                'endDateRange': {
                    'begindate': enddateData.beginDate,
                    'enddate': enddateData.endDate
                }
            }
        },
        getBusinessYears(date) {
            let endDate
            const day = moment.utc(date)

            const curyear = day.year()

            const firstofyear = day.clone().startOf('year').format("dddd").toLowerCase()
            const endofyear = day.clone().endOf('year').format("dddd").toLowerCase()

            const firstDiff = weekdiff[firstofyear].saturday
            const endDiff = weekdiff[endofyear].friday

            const endofyearM = moment.utc(`${curyear}-12-31`)

            if (endofyearM.day() === 5) {
                // last day of the year is a friday

                endDate = endofyearM.format("YYYY-MM-DD")
            } else if (day.clone().endOf('year').add(endDiff, 'days').year() != curyear) {
                // the friday of the last week of the year
                // is in the next year

                endDate = day.clone().endOf('year').add(endDiff, 'days').subtract(7, 'days').format("YYYY-MM-DD")
            } else {
                // the friday of the last week of the year
                // is in the this year

                endDate = day.clone().endOf('year').add(endDiff, 'days').format("YYYY-MM-DD")
            }

            return {
                'beginDate': day.clone().startOf('year').add(firstDiff, 'days').format("YYYY-MM-DD"),
                'endDate': endDate
            }
        },
        getBeginEndBusinessYears(begindate, enddate) {

            const begindateData = this.getBusinessYears(begindate)
            const enddateData = this.getBusinessYears(enddate)

            return {
                'beginDateRange': {
                    'begindate': begindateData.beginDate,
                    'enddate': begindateData.endDate
                },
                'endDateRange': {
                    'begindate': enddateData.beginDate,
                    'enddate': enddateData.endDate
                }
            }
        },
        logActivity(action, params) {
            QuilityAPI.logActivty(action, this.$route.name, this.$route.path, params)
        },
        logTabActivty(tab) {
            QuilityAPI.logActivty('TabClick', tab, this.$route.path, {})
        },
        getAvailableBusinessDates(stat_period, allowNextWeek, allowCurrent, earliestDate = null, currentUsesActualDates = false) {

            //allow for a later starting point other than 52 weeks or 18 months ago
            if (earliestDate == null)
                earliestDate = new Date("2000-01-01")
            else
                earliestDate = new Date(earliestDate)


            if (stat_period == 'weeks' || stat_period == 'week') {
                var weeks = [];
                var current = moment()
                var day_of_the_week = moment().format('dddd');
                if (allowNextWeek) {
                    weeks.push({
                        label: 'Next Week',
                        endDate: null, //moment(current).format('YYYY-MM-DD'),
                        startDate: null, //moment(current).subtract(weekdiff[day_of_the_week]['saturday'], 'days').format('YYYY-MM-DD'),
                        period: 'week'
                    })
                    var current = moment().add(1, "week");
                }
                if (allowCurrent) {
                    if (currentUsesActualDates){
                        weeks.push({
                            label: moment(current).subtract(6, 'days').format('ddd MMM Do') + " - " + moment(current).format('ddd MMM Do'),
                            endDate: moment(current).format('YYYY-MM-DD'),
                            startDate: moment(current).subtract(weekdiff[day_of_the_week]['saturday'], 'days').format('YYYY-MM-DD'),
                            period: 'week'
                        })
                    }else{
                        weeks.push({
                            label: 'Current Week',
                            endDate: null, //moment(current).format('YYYY-MM-DD'),
                            startDate: null, //moment(current).subtract(weekdiff[day_of_the_week]['saturday'], 'days').format('YYYY-MM-DD'),
                            period: 'week'
                        })
                    }
                }
                //start at last week
                current = moment(current).subtract(weekdiff[day_of_the_week]['friday'], 'days')
                for (var i = 0; i < 52; i++) {
                    if (moment(current).subtract(6, 'days') > earliestDate) {
                        weeks.push({
                            label: moment(current).subtract(6, 'days').format('ddd MMM Do') + " - " + moment(current).format('ddd MMM Do'),
                            endDate: moment(current).format('YYYY-MM-DD'),
                            startDate: moment(current).subtract(6, 'days').format('YYYY-MM-DD'),
                            period: 'week'
                        })
                    }
                    current.subtract(7, 'days')
                }
                return weeks;
            } else {
                var months = [];
                var current = moment();

                // If the last Friday of the month is less than today go to the first day of the next month
                // This prevents returning the previous period that doesn't include the current date
                let last_friday_of_month = moment().endOf('month');
                while (last_friday_of_month.day() !== 5) {
                    last_friday_of_month.subtract(1, 'days');
                }
                if (last_friday_of_month < current) {
                    current.add(1, 'month').date(1);
                }

                var day_of_the_week = moment(current).startOf('month').format('dddd');
                var first_day_of_business_month = moment(current).startOf('month').subtract(weekdiff[day_of_the_week]['saturday'], 'days');
                if (allowCurrent) {
                    if (currentUsesActualDates){
                        months.push({
                            label: moment(current).format("MMM 'YY"),
                            endDate: moment(current).format('YYYY-MM-DD'),
                            startDate: first_day_of_business_month.format('YYYY-MM-DD'),
                            period: 'month'
                        })
                    }else{
                        months.push({
                            label: 'Current Month',
                            endDate: null, //moment(current).format('YYYY-MM-DD'),
                            startDate: null, //first_day_of_business_month.format('YYYY-MM-DD'),
                            period: 'month'
                        })
                    }
                }
                current = current.subtract(1, 'months')
                day_of_the_week = moment(current).startOf('month').format('dddd');
                var endDate = first_day_of_business_month.subtract(1, "days").format('YYYY-MM-DD');
                first_day_of_business_month = moment(current).startOf('month').subtract(weekdiff[day_of_the_week]['saturday'], 'days');
                for (var i = 0; i < 18; i++) {
                    if (first_day_of_business_month > earliestDate) {
                        months.push({
                            label: moment(current).format("MMM 'YY"),
                            endDate: endDate,
                            startDate: first_day_of_business_month.format('YYYY-MM-DD'),
                            period: 'month'
                        })
                    }
                    endDate = first_day_of_business_month.subtract(1, "days").format('YYYY-MM-DD');
                    current = current.subtract(1, 'months')
                    var day_of_the_week = moment(current).startOf('month').format('dddd');
                    first_day_of_business_month = moment(current).startOf('month').subtract(weekdiff[day_of_the_week]['saturday'], 'days');
                }
                return months;
            }
        },
        getBusinessDates(stat_period, the_date) {
            if (stat_period == 'weeks' || stat_period == 'week') {
                //TODO
            } else {
                var months = [];
                var current = moment(the_date);
                // get the last friday of the month
                var lastDay = current.endOf('month');
                while (lastDay.day() !== 5) { 
                    lastDay.subtract(1,'days')
                }
                var endDate = lastDay.format('YYYY-MM-DD');

                //get last friday of last month
                var last_month = current.subtract(1, 'months');
                var lastDay = last_month.endOf('month');
                while (lastDay.day() !== 5) { 
                    lastDay.subtract(1,'days')
                }
                var startDate = lastDay.add(1,'days').format('YYYY-MM-DD');

                return {
                    label: moment(current).format("MMM 'YY"),
                    endDate: endDate,
                    startDate: startDate,
                    period: 'month'
                };
            }
        },
        setPageTitle(title) {
            if (!title) {
                document.title = 'Quility HQ';
            } else {
                document.title = `${title} || Quility HQ`
            }
        },
        getColor(color) {
            const vuetifyColor = this.$vuetify.theme.currentTheme[color]
            return vuetifyColor ? vuetifyColor : color
        },
        getTenantColor(tenant_id) {
            var t = Tenant.find(tenant_id);
            if (t) {
                return t.TenantConfig.features.UIColor.hex;
            }
            return '#46c3b2';
        },
        getTenantPrefix(tenant_id) {
            var t = Tenant.find(tenant_id);
            if (t) {
                return t.AgentCodePrefix;
            }
            return '?';
        },
        tenantHasFeature(feature, tenant_id) {
            if (typeof tenant_id == 'undefined') {
                tenant_id = this.current_tenant.ID
            }
            var t = Tenant.find(tenant_id);
            if (typeof t == "undefined" || t == null) {
                return false;
            }
            if (typeof t.TenantConfig.features == "undefined" || t.TenantConfig.features == null) {
                return false;
            }
            var f = feature.split(".");
            var feature_path = t.TenantConfig.features;
            f.forEach(function(item) {
                feature_path = feature_path[item]
            })
            if (typeof feature_path == "undefined" || feature_path == null) {
                return false
            }
            if (typeof feature_path == "boolean") {
                return feature_path;
            }
            return true;
        },
        getTenant: function(id) {
            return Tenant.find(id);
        },
        pluck(array, key) {
            return array.map(o => o[key]);
        },
        defaultCmsColumnSubBlocks(text) {
            if (!text)
                text = "Sed nec diam non eros lobortis tempor et eget sapien. Sed rutrum orci eget ligula mattis, vel vestibulum ligula feugiat. Cras et velit ut ipsum fringilla vulputate."
            var new_id = Math.random()
            return [{
                type: "full-width-text",
                text: text,
                id: new_id,
                type: 'full-width-text',
                hasFocus: false,
                styles: [],
                permissions: { role: null, permission: null, division: null },
                CarrierID: null,
                CarrierIDs: null,
                key: new_id
            }]
        },
        blockClasses(block, other) {
            if (typeof block.styles != 'object') {
                this.$set(block, 'styles', [])
            }
            var classes = [
                ...block.styles,
                block.type,
                other
            ]
            return classes.join(' ')
        },
        showBlock(block) {
            if (block.status === 'draft')
                return false

            if (block.startDate !== null && block.startDate !== undefined && block.startDate !== "") {
                if (!moment(block.startDate).isSameOrBefore(moment(), 'day'))
                    return false
            }

            if (block.endDate !== null && block.endDate !== undefined && block.endDate !== "") {
                if (!moment(block.endDate).isSameOrAfter(moment(), 'day'))
                    return false
            }


            let permissionsAreSetFor = function(obj) {
                if (!obj)
                    return false
                if (typeof obj == 'string' && obj.length > 0)
                    return true
                if (typeof obj != 'string' && obj.length > 0)
                    return true
                return false
            }

            //check roles
            if (permissionsAreSetFor(block.permissions.role)) {
                if (block.permissions.exclude == 'exclude') {
                    if (block.permissions.role == 'Any' || this.hasRole(block.permissions.role)) {
                        return false
                    }
                } else if (!this.hasRole(block.permissions.role) && block.permissions.role != 'Any') {
                    return false
                }
            }

            //check permission
            if (permissionsAreSetFor(block.permissions.permission)) {
                if (block.permissions.exclude == 'exclude') {
                    if (block.permissions.permission == 'Any' || this.hasPermission(block.permissions.permission)) {
                        return false
                    }
                } else if (!this.hasPermission(block.permissions.permission) && block.permissions.permission != 'Any') {
                    return false
                }
            }

            //passed all checks
            return true
        }
    },
    computed: {
        role: function() {
            if (this.$auth.isAuthenticated) {
                if (typeof this.$auth.auth_user["http://quility.com/roles"] == "undefined") {
                    return null
                }
                return this.$auth.auth_user["http://quility.com/roles"][0];
            }
            return null;
        },
        roles: function() {
            if (this.$auth.user) {
                return this.$auth.auth_user["http://quility.com/roles"];
            }
            return [];
        },
        'role_choices': function() {
            if (this.hasRole("SuperAdmin")) {
                return [
                    'UnlicensedAgent',
                    'SalesRep',
                    'AgencyOwner',
                    'Staff',
                    'SuperAdmin'
                ]
            }
            return [
                'UnlicensedAgent',
                'SalesRep',
                'AgencyOwner',
                'Staff',
            ]
        },
        'permission_choices': function() {
            //sort our permissions... 
            return Object.keys(this.user.admin.AvailablePermissions).map(f => this.user.admin.AvailablePermissions[f].value).sort()
        },
        current_tenant: function() {
            if (this.user?.currentSetTenantID != null) {
                return Tenant.find(this.user.currentSetTenantID);
            }
            return this.user?.Agent.TenantID
        },
        all_tenants: function() {
            return Tenant.all()
        },
        all_enabled_tenants: function() {
            return Tenant.query().where('EnabledInd', true).get()
        },
        tenant_select: function() {
            var tenants = Tenant.all();
            var t = []
            tenants.forEach(function(tenant) {
                t.push({
                    text: tenant.Tenant,
                    value: tenant.ID
                })
            })
            return t
        },
        /** todo_Division */
        divisions: function() {
            if (this.user.currentSetTenantID != null) {
                return [this.user.currentSetTenantID];
            }
            if (this.user.permissions.length > 0) {
                var d = [];
                for (var i = 0; i < this.user.permissions.length; i++) {
                    if (this.user.permissions[i].indexOf("division:") > -1) {
                        d.push(this.user.permissions[i].replace('division:', ''))
                    }
                }
                return d;
            }
            return [];
        },
        /** todo_Division */
        raw_divisions: function() {
            if (this.user.permissions.length > 0) {
                var d = [];
                for (var i = 0; i < this.user.permissions.length; i++) {
                    if (this.user.permissions[i].indexOf("division:") > -1) {
                        d.push(this.user.permissions[i].replace('division:', ''))
                    }
                }
                return d;
            }
            return [];
        },
        user_meta: function() {
            if (this.$auth.isAuthenticated && this.$auth.auth_user["http://quility.com/meta_data"]) {
                return this.$auth.auth_user["http://quility.com/meta_data"];
            }
            return {};
        },
        user() {
            return User.query().first();
        },
        form_rules() {
            return {
                'required': v => !!v || 'Required!',
                'date': function(v) {
                    if (typeof v == 'undefined' || v == null || v == '') {
                        return true
                    }
                    if (moment(v, 'YYYY-MM-DD', true).isValid()) {
                        return true;
                    }
                    return 'Enter a valid date';
                },
                'time': function(v) {
                    if (typeof v == 'undefined' || v == null || v == '') {
                        return true
                    }
                    if (moment('2020/1/1 ' + v).isValid()) {
                        return true;
                    }
                    return 'Enter a valid time';
                },
                'number': function(v) {
                    if (typeof v == 'undefined' || v == null || v == '') {
                        return true
                    }
                    v = Number(v);
                    if (typeof v === 'number' && isFinite(v)) {
                        return true;
                    }
                    return 'Enter a number';
                },
                'int': function(v) {
                    if (typeof v == 'undefined' || v == null || v == '') {
                        return true
                    }
                    if (Number.isInteger(v)) {
                        return true;
                    }
                    return 'Enter a whole number';
                },
                'email': v => !v || /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
                'zip': v => /^[0-9]{5}(?:-[0-9]{4})?$/.test(v) || 'Enter a valid zipcode', // explnation of this regex can be found here https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch04s14.html
                'phone': function(v) {
                    if (typeof v == 'string') {
                        v = v.replaceAll("-", "")
                        if (v != null && (Number.isInteger(Number(v)) && v.length >= 10)) {
                            return true
                        }
                    }
                    return 'Please enter a valid phone number in the phone field.'
                },
                'not_upper_case': function(v) {
                    if (typeof v == 'undefined') {
                        return true
                    }
                    if (v == null || v.length <= 2) {
                        return true;
                    }
                    if (v !== v.toUpperCase()) {
                        return true;
                    }
                    return 'Please do not use all upper case.';
                },
                'no_special_characters': function(v) {
                    if (v == null || typeof v == 'undefined') {
                        return true
                    }

                    // make sure we're working with a string
                    const str = v.toString()
                    const matches = str.match(/([a-z]|[A-Z]|[']|[-]|[\s])/g) || []

                    if (str.length == matches.length) {
                        return true
                    }

                    return 'Please do not add any special characters.'
                },
                'valid_name_characters': function(v) {
                    if (v == null || typeof v == 'undefined') {
                        return true
                    }

                    // make sure we're working with a string
                    const str = v.toString()
                    const matches = str.match(/([a-z]|[A-Z]|[']|[-]|[\s]|[&])/g) || []

                    if (str.length == matches.length) {
                        return true
                    }

                    return 'Please do not add any special characters.'
                },
                'json': function(v) {
                    try {
                        JSON.parse(v);
                    } catch (e) {
                        return 'Please enter valid JSON';
                    }
                    return true;
                }
            }
        },
        isDirectToSymmetry() {
            return this.user.DirectAgencyOwner.AgentCode == 'SFG0000001'
        },
        isAgent() {
            return this.hasRole(['AgencyOwner', 'SalesRep']);
        },
        isImpersonating() {
            if (typeof this.user_meta.RevertAgentCode == 'undefined') {
                return false;
            }
            return this.user_meta.RevertAgentCode !== null;
        },
        accountManager() {
            const accountManager = this.user?.config?.AccountManager?.ConfigValue?.user
            const quilityEmailSuffix = 'quility.com'

            return accountManager
                ? {
                    ...accountManager,
                    email: accountManager.emails?.find(({ address }) => address.includes(quilityEmailSuffix))?.address || accountManager.emails?.[0]?.address,
                    phone: accountManager.phones?.[0] ? accountManager.phones?.[0]['displayPhone'] : null,
                }
                : null
        },
    }
}